// ポンカン予約LP: 規格（家庭用・訳あり）と内容量（3・5・10kg）のボタンから、実際の商品（variant）を選んでフォームに入れる
// 2026-10-11 参考LPの選び方をそのまま使い、価格・在庫は商品データ（data-ponkan-variants）から出す
(function () {
  var form = document.querySelector('.order-form');
  var dataEl = form && form.querySelector('[data-ponkan-variants]');
  if (!form || !dataEl) return;
  var variantMap;
  try { variantMap = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var idInput = form.querySelector('input[name="id"]');
  var nameEl = form.querySelector('[data-choice-name]');
  var priceEl = form.querySelector('[data-choice-price]');
  var submit = form.querySelector('[data-choice-submit]');
  var grades = { home: '家庭用', wakeari: '訳あり' };
  var pick = function (selector, attr) {
    var el = form.querySelector(selector + '.is-selected');
    return el ? el.getAttribute(attr) : null;
  };
  var grade = pick('[data-grade]', 'data-grade') || 'home';
  var weight = pick('[data-weight]', 'data-weight') || '3';

  function render() {
    var v = variantMap[grade + '-' + weight];
    nameEl.textContent = grades[grade] + '・' + weight + 'kg';
    if (v && v.available) {
      idInput.value = v.id;
      priceEl.textContent = v.price;
      submit.disabled = false;
    } else {
      var soldOut = document.createElement('small');
      soldOut.textContent = '売り切れ';
      priceEl.replaceChildren(soldOut);
      submit.disabled = true;
    }
    form.querySelectorAll('[data-grade]').forEach(function (b) { var yes = b.dataset.grade === grade; b.classList.toggle('is-selected', yes); b.setAttribute('aria-pressed', String(yes)); });
    form.querySelectorAll('[data-weight]').forEach(function (b) { var yes = b.dataset.weight === weight; b.classList.toggle('is-selected', yes); b.setAttribute('aria-pressed', String(yes)); });
  }
  form.querySelectorAll('[data-grade]').forEach(function (b) { b.addEventListener('click', function () { grade = b.dataset.grade; render(); }); });
  form.querySelectorAll('[data-weight]').forEach(function (b) { b.addEventListener('click', function () { weight = b.dataset.weight; render(); }); });
  render();
})();

// 2026-10-11 切り方のスライダー: 前へ・次へで1枚ずつ送り、何枚目かを表示。端ではボタンを押せなくする
(function () {
  var track = document.querySelector('[data-howto-track]');
  if (!track) return;
  var root = track.closest('.howto-slider');
  var prev = root.querySelector('[data-howto-prev]');
  var next = root.querySelector('[data-howto-next]');
  var count = root.querySelector('[data-howto-count]');
  var slides = track.querySelectorAll('.howto-slide');
  var step = function () {
    if (slides.length < 2) return track.clientWidth;
    return slides[1].offsetLeft - slides[0].offsetLeft;
  };
  var update = function () {
    var i = Math.round(track.scrollLeft / step());
    var max = track.scrollWidth - track.clientWidth;
    count.textContent = Math.min(i + 1, slides.length) + ' / ' + slides.length;
    prev.disabled = track.scrollLeft <= 2;
    next.disabled = track.scrollLeft >= max - 2;
  };
  prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
  next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
  track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
  window.addEventListener('resize', update);
  update();
})();

// 2026-10-11 スクロールで次のまとまりがふわっとフェードで現れる（ファーストビューは最初から表示。動きを減らす設定では何もしない）
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var selectors = ['.essentials .container', '.intro-header', '.taste-layout', '.howto-head', '.howto-slider', '.field-lead', '.landscape-photo', '.field-story', '.photo-duo', '.grower-layout', '.moment-head', '.moment-cols', '.res-lead', '.timeline', '.order-box', '.ordersub', '.faq-layout', '.last-content', '.last-image'];
  var targets = document.querySelectorAll(selectors.join(','));
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-shown');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  targets.forEach(function (el) {
    // すでに画面内にあるものはそのまま表示（読み込み直後にちらつかせない）
    if (el.getBoundingClientRect().top < window.innerHeight * 0.9) return;
    el.classList.add('is-reveal');
    observer.observe(el);
  });
})();
